import React from "react";
import asyncComponent from "../../pages/main/asyncComponent";
import Report4Right1 from "../../pages/components/customer/ReportDetail4Right1"; // Right Gait & Posture 这个版本是传id
import Report4Right2 from "../../pages/components/customer/ReportDetail4Right2"; // Right Gait & Posture 这个版本是传uuid
import Report4Right2V2 from "../../pages/components/customer/ReportDetail4RightV2"; // Right Gait & Posture 这个版本是传uuid v2
import Report4Right2V0 from "../../pages/components/customer/ReportDetail4RightV0"; // Right Gait & Posture 这个版本是传uuid v0
import Log from "../../pages/components/customer/ReportLog"

const Report = asyncComponent(() => import("../../pages/components/report/report"));
const Reportv2 = asyncComponent(() => import("../../pages/components/v2/report"));

const routes = [
  {
    path: "/report",
    exact: true,
    component: Report,
    authorized: false,
  },
  {
    path: "/v2/report",
    exact: true,
    component: Reportv2,
    authorized: false,
  },
  {
    path: "/reportDetail/:id",
    component: Report4Right1,
  },
  {
    path: "/reports/:uuid",
    component: Report4Right2,
  },
  {
    path: "/v1/static-reports/:uuid",
    component: Report4Right2,
  },
  {
    path: "/v2/reports/:uuid",
    component: Report4Right2V2,
  },
  {
    path: "/v2/static-reports/:uuid",
    component: Report4Right2V2,
  },
  {
    path: "/v0/static-reports/:uuid",
    component: Report4Right2V0,
  },
  {
    path: "/log/static-reports/:uuid",
    component: Log,
  },
];

export default routes;
